import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { cn } from '@/lib/cn';

interface DeltaBadgeProps {
  current: number;
  previous: number;
  /** Label for the metric (e.g. "views"). */
  label?: string;
  className?: string;
}

export function DeltaBadge({ current, previous, label, className }: DeltaBadgeProps) {
  if (previous === 0) return null;

  const pct = Math.round(((current - previous) / previous) * 100);
  const isUp = pct > 0;
  const isFlat = pct === 0;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-0.5 text-[11px] font-medium',
        isFlat && 'text-muted-foreground',
        isUp && 'text-emerald-600 dark:text-emerald-400',
        !isUp && !isFlat && 'text-red-600 dark:text-red-400',
        className,
      )}
      title={label ? `${label} change vs previous snapshot` : undefined}
    >
      {isFlat ? (
        <Minus className="h-3 w-3" />
      ) : isUp ? (
        <TrendingUp className="h-3 w-3" />
      ) : (
        <TrendingDown className="h-3 w-3" />
      )}
      {isFlat ? '—' : `${isUp ? '+' : ''}${pct}%`}
    </span>
  );
}
